export default __webpack_public_path__ + "static/media/CNo.75-0.f600fa17.jpg";